const topCntnt = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;

    const secCntnt = document.getElementById("jsSecCntnt")
    const cntntWrapWraps = secCntnt.querySelectorAll(".js-cntnt-wrap-wrap");
    const cntntWraps = secCntnt.querySelectorAll(".js-cntnt-wrap");

    const header = document.querySelector("header.header");
    const navSpFloat = document.getElementById("jsNavSpFloat");
    let headerH = header.clientHeight;
    let navSpFloatH = navSpFloat.clientHeight;

    let volX = sW * 0.1
    let volY = sW * 0.05

    cntntWraps.forEach(element => {

      gsap.set(element, {
        x: volX,
        y: volY,
        autoAlpha: 0,
      });

    });


    cntntWraps.forEach((element, index) => {

      let to1 = gsap.to(element, {
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "none",
        scrollTrigger: {
          trigger: cntntWrapWraps[index],
          start: `0% 100%-=${navSpFloatH}`,
          end: `0% 60%+=${headerH}`,
          scrub: 2,
          // markers: true,
        }
      });

      let to2 = gsap.to(cntntWrapWraps[index], {
        x: volX,
        y: -volY,
        autoAlpha: 0,
        ease: "none",
        scrollTrigger: {
          trigger: cntntWrapWraps[index],
          start: `50% 30%-=${navSpFloatH}`,
          end: `50% 0%+=${headerH}`,
          scrub: 2,
          // markers: true,
        }
      });

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          // console.log('observer');
          to1.scrollTrigger.refresh()
          to2.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    });



    const secBg = document.getElementById("jsSecBg")
    const cntntBgWrap = secBg.querySelector(".js-cntnt-bg-wrap");
    const bgBoxs = cntntBgWrap.querySelectorAll(".js-bg-box");

    ScrollTrigger.create({
      trigger: secCntnt,
      start: `-200px 100%`,
      endTrigger: 'body',
      end: "100% 0%",
      toggleClass: { targets: bgBoxs[0], className: "act" },
      // markers: true,
    });

    for (let i = 1; i < bgBoxs.length; i++) {

      ScrollTrigger.create({
        trigger: cntntWrapWraps[i - 1],
        start: `50% 30%-=${navSpFloatH}`,
        endTrigger: 'body',
        end: "100% 0%",
        toggleClass: { targets: bgBoxs[i], className: "act" },
        // markers: true,
      });

    }



    if (sW >= 768) {

      cntntWraps.forEach(element => {

        let imgBox = element.querySelector(".js-img-box");
        let btnBox = element.querySelector(".js-btn-box");
        let btn = btnBox.querySelectorAll("a");

        for (let i = 0; i < btn.length; i++) {

          btn[i].addEventListener('mouseover', () => {
            imgBox.classList.add('hover')
          });

          btn[i].addEventListener('mouseleave', () => {
            imgBox.classList.remove('hover')
          });

        }

      });
      
    }



  }
})()
export default topCntnt;